import { createFileRoute } from '@tanstack/react-router'
import { UserOnboarding } from '../../components/onboarding/UserOnboarding'

export const Route = createFileRoute('/onboarding/user')({
  component: UserOnboarding,
})
